import { useContext, useEffect, useState } from 'react'
import { getProductosContrato } from '../../../pages/AdminLocal/services/contratos.productos.services'
import { IProductoContrato } from '../../../pages/AdminProducts/types/producto'
import { TenantsContext } from '../../../context/tenants.context'

export const useProductosContrato = () => {
  const [productos, setProductos] = useState<IProductoContrato[]>([])
  const { tenant } = useContext(TenantsContext)

  const fetchProductosContrato = async () => {
    getProductosContrato(tenant)
      .then(({ data }) => {
        setProductos(data.data.results)
      })
      .catch((error) => {
        console.log(error)
      })
  }

  useEffect(() => {
    fetchProductosContrato()
  }, [])

  return { productos, fetchProductosContrato }
}
